import React from 'react';

import { SkeletonLoader } from '@sm/webassets';

const FilterNavSkeleton = props => {
  return (
    <>
      <SkeletonLoader width={258} height={150} {...props}>
        <rect x="0" y="0" ry="0" width="258" height="28" />
        <rect x="40" y="0" ry="0" width="258" height="28" />
        <rect x="80" y="0" ry="0" width="258" height="28" />
      </SkeletonLoader>
    </>
  );
};

export default FilterNavSkeleton;
